import cookies from "@helpers/cookies";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { GWG_SOURCE } from "../../constants";

export const useGwgTracking = () => {
  const router = useRouter();
  useEffect(() => {
    // Set the cookie with expiry for any utm_source values.
    if (router.isReady && router.query.utm_source) {
      // Expires in 30 days.
      cookies().setWithExpiry(
        GWG_SOURCE,
        30,
        router.query.utm_source as string
      );
    }
  }, [router.isReady, router.query]);
  return null;
};

export const getGwgSource = () => {
  return cookies().getWithoutExpiryUpdate(GWG_SOURCE);
};
